/* AM-BUNDLE-CART — conecta el widget de packs con el carrito lateral.
   Se carga DESPUES de am-bundle.js y reemplaza el comportamiento del CTA.

   POR QUE EXISTE ESTE ARCHIVO EN VEZ DE TOCAR am-bundle.js:
   el widget tiene que poder funcionar solo, sin carrito lateral, si alguna
   vez se usa en otra pagina o si el carrito se desactiva. Manteniendo la
   conexion aparte, cada pieza sigue siendo independiente.

   POR QUE XHR Y NO FETCH: Kaching Cart y otras apps envuelven window.fetch
   para detectar altas al carrito y abrir SU propio drawer. Con tres
   carritos en la misma pagina (el de Shrine, el de Kaching y el nuestro)
   se pisan entre ellos. XHR no lo intercepta nadie. */
(function(){
  var root = document.querySelector('[data-am-bundle]');
  var drawer = document.querySelector('[data-amc-drawer]');
  if(!root || !drawer) return;

  var add = root.querySelector('[data-am-add]');
  if(!add) return;

  // Clonar descarta los listeners que puso am-bundle.js sobre este boton
  var btn = add.cloneNode(true);
  add.parentNode.replaceChild(btn, add);

  var label  = btn.querySelector('[data-am-cta-text]');
  var errBox = root.querySelector('[data-am-error]');
  var buy    = root.querySelector('[data-am-buynow]');
  var busy   = false;

  function showError(m){ if(errBox){ errBox.textContent = m; errBox.hidden = false; } }
  function hideError(){ if(errBox) errBox.hidden = true; }

  // Cuando el carrito se abre encima, el cartel del widget queda tapado:
  // el aviso tiene que salir en el panel que el cliente esta mirando.
  function drawerError(m){
    var e = drawer.querySelector('[data-amc-error]');
    if(e){ e.hidden = false; e.textContent = m; }
  }

  // Shopify contesta casi siempre en castellano, y su texto es mas preciso
  // que cualquier generico. Solo se reemplaza lo que vuelve en ingles.
  function motivo(status, d){
    var t = ((d && (d.description || d.message)) || '') + '';
    if(/cannot find variant|not found/i.test(t)) return 'Esa combinación ya no está disponible. Probá con otro color.';
    if(/sold out|out of stock|unavailable/i.test(t)) return 'Se agotó alguna de esas opciones. Probá con otro color.';
    if(/you can only add|maximum quantity|in your cart/i.test(t)) return 'No queda stock suficiente de alguna de esas opciones.';
    if(t && !/\b(the|your|cart|item|items|quantity|available|add|stock|sold|only|please)\b/i.test(t)) return t;
    if(status === 422) return 'No hay stock suficiente de alguna de esas opciones.';
    return 'No pudimos agregar el pack. Reintentá en un momento.';
  }

  // Reconstruye la seleccion actual leyendo el DOM del pack elegido.
  // No depende de variables internas de am-bundle.js.
  function itemsFromDom(){
    var tier = root.querySelector('.am-tier.is-selected');
    if(!tier) return null;
    var variantes = JSON.parse(root.querySelector('[data-am-variants]').textContent)
      .filter(function(v){ return v.available; });

    var byId = {}, ok = true;
    Array.prototype.forEach.call(tier.querySelectorAll('[data-am-slot]'), function(slot){
      /* La seleccion se arma POR NIVEL, no por orden de aparicion.
         Cada select trae su nivel en dataset.level (lo escribe am-bundle.js).
         Antes se usaba el indice del forEach como nivel, y eso se desfasaba
         apenas un nivel no dibujara su desplegable: el color se comparaba
         contra la capacidad, no habia match, y el boton Agregar quedaba mudo
         diciendo "esa combinacion no esta disponible" mientras Comprar ahora
         seguia andando por otro camino. */
      var elegido = [], vistos = 0;
      Array.prototype.forEach.call(slot.querySelectorAll('select'), function(s){
        var nivel = parseInt(s.dataset.level, 10);
        if(isNaN(nivel)) nivel = vistos;
        elegido[nivel] = s.value;
        vistos++;
      });
      if(!vistos){ ok = false; return; }
      var v = variantes.find(function(x){
        return x.options.every(function(op, i){
          return elegido[i] === undefined || elegido[i] === op;
        });
      });
      if(!v){ ok = false; return; }
      byId[v.id] = (byId[v.id] || 0) + 1;
    });
    if(!ok) return null;
    var out = Object.keys(byId).map(function(id){
      return { id: parseInt(id, 10), quantity: byId[id] };
    });
    return out.length ? out : null;
  }

  btn.addEventListener('click', function(){
    if(busy) return;
    var items = itemsFromDom();
    if(!items){
      showError('Esa combinación no está disponible. Probá con otro color.');
      return;
    }
    busy = true;
    btn.disabled = true;
    if(buy) buy.disabled = true;
    if(label) label.textContent = 'Agregando…';
    hideError();

    function restore(){
      busy = false;
      btn.disabled = false;
      if(buy) buy.disabled = false;
      if(!label) return;
      // El texto se RECONSTRUYE del pack que esta elegido AHORA, no se
      // restaura una foto tomada antes del pedido. /cart/add.js tarda
      // cerca de un segundo en fibra y varios en 4G: en esa ventana el
      // cliente puede tocar otro pack, y devolverle el texto viejo dejaba
      // el boton diciendo "$39.950" con cuatro unidades en el carrito.
      var tier = root.querySelector('.am-tier.is-selected');
      var tot  = tier && tier.querySelector('[data-am-total]');
      var txt  = tot && tot.textContent.trim();
      label.textContent = txt ? ('Agregar al carrito • ' + txt) : 'Agregar al carrito';
    }

    var x = new XMLHttpRequest();
    x.open('POST', '/cart/add.js', true);
    x.timeout = 10000;
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', 'application/json');

    x.onload = function(){
      restore();
      if(x.status >= 200 && x.status < 300){
        document.dispatchEvent(new CustomEvent('am:cart:open'));
        return;
      }
      var d = null;
      try { d = JSON.parse(x.responseText); } catch(e){}
      var texto = ((d && (d.description || d.message)) || '') + '';

      // UN 422 NO SIEMPRE SIGNIFICA QUE NO SE AGREGO NADA.
      //
      // Medido en la tienda: con 119 unidades en el carrito y un pack de 4,
      // Shopify contesta 422 y IGUAL agrega las 2 que quedaban. El alta
      // multiple es atomica cuando la variante no existe o esta agotada,
      // pero NO cuando lo que falta es disponibilidad: ahi recorta. El caso
      // real no es alguien con 119 unidades: es un color con 3 en stock y
      // un pack de 4.
      // Como antes solo se pintaba el cartel rojo y no se tocaba el
      // carrito, el cliente leia "no hay stock" con unidades ya adentro, y
      // al volver a tocar Agregar recibia otro mensaje distinto ("tu
      // carrito ya tiene la cantidad maxima") sin entender por que.
      //
      // Los dos casos se distinguen por el texto de Shopify: el del recorte
      // trae la cifra ("solo se anadieron N articulos"), el del rechazo
      // total no trae ningun numero.
      //
      // El texto propio reemplaza al de Shopify a proposito: "solo se
      // anadieron 121 articulos al carrito" se lee como que agrego 121,
      // cuando 121 es el total que quedo y lo agregado fueron 2.
      //
      // OJO CON EL DISCRIMINADOR: no alcanza con preguntar si el texto trae
      // algun digito. Los nombres de variante de esta tienda son "500ml /
      // Blanco", "750ml / Violeta", "1L": todos traen numeros. Un 422 de
      // rechazo TOTAL que nombre la variante pasaria por recorte parcial y
      // el cliente leeria "agregamos solo las unidades que quedaban" con el
      // carrito intacto. Por eso el numero tiene que venir pegado a una
      // palabra de cantidad.
      if(x.status === 422 && /\b\d+\s*(art[íi]culos?|unidades?|items?)\b/i.test(texto)){
        document.dispatchEvent(new CustomEvent('am:cart:open'));
        drawerError('Agregamos solo las unidades que quedaban en stock. Revisá el carrito.');
        return;
      }

      showError(motivo(x.status, d));
    };

    x.onerror = x.ontimeout = function(){
      restore();
      // OJO: /cart/add.js NO es idempotente. Si el pedido llego al
      // servidor y lo que se perdio fue la respuesta, el pack YA esta en
      // el carrito. El mensaje anterior decia "reintenta en un momento":
      // el cliente reintentaba y se llevaba (y pagaba) el doble.
      //
      // Con la conexion caida no hay forma de saber cual de los dos casos
      // es, asi que no se afirma ninguno: se abre el carrito — que se
      // refresca solo contra el servidor — y se deja que lo vea.
      document.dispatchEvent(new CustomEvent('am:cart:open'));
      drawerError('No pudimos confirmar si se agregó. Fijate acá abajo antes de volver a intentar.');
    };

    x.send(JSON.stringify({ items: items }));
  });

  /* VOLVER DESDE bfcache DEJA EL BOTON SORDO.
     iOS Safari y Chrome Android guardan la pagina entera al navegar y la
     devuelven tal cual al tocar Atras: con `busy` en true si la respuesta
     nunca llego, y con el boton deshabilitado. am-bundle.js tiene su propio
     descongelar() para lo mismo, pero solo alcanza al DOM — esta bandera
     vive en otro closure y nadie mas la puede bajar.
     Sin esto el boton se ve normal y no responde a ningun toque, que es
     peor que verse deshabilitado: el cliente no entiende que pasa y se va. */
  window.addEventListener('pageshow', function(e){
    if(!e.persisted) return;
    busy = false;
    btn.disabled = false;
    if(buy) buy.disabled = false;
    var tier = root.querySelector('.am-tier.is-selected');
    var tot  = tier && tier.querySelector('[data-am-total]');
    var txt  = tot && tot.textContent.trim();
    if(label) label.textContent = txt ? ('Agregar al carrito • ' + txt) : 'Agregar al carrito';
  });
})();
